import { Icon } from '@iwoca/orion';
import styles from './StatusIcons.module.css';
import classNames from 'classnames';

const Required = () => {
    return (
        <span
            className={classNames(styles.status, styles.requiredStatus)}
            data-testid="required-status"
        >
            <Icon
                className={classNames(styles.statusIcon, styles.requiredIcon)}
                icon="exclamationTriangleFilled"
                height={20}
                width={20}
            />
            Required
        </span>
    );
};

// eslint-disable-next-line import/no-default-export
export default Required;
